<template>
  <section class="white lighten-4">
    <template v-if="isLoading">
      <div class="bg-white flex justify-center items-center h-96 fixed w-full max-w-md mx-auto">
        <div class="text-center">
          <h1>
            <v-icon class="animate-spin text-3xl" size="50" color="primary">mdi-cached</v-icon>
          </h1>
          <p>Please wait...</p>{{ $t('project.project_loading') }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="green lighten-5">
        <v-container style="max-width: 1800px">
          <v-row>
            <v-col cols="12">
              <v-card flat color="transparent">
                <v-card-text>
                  <h1 class="mb-0 font-weight-bold" style="color: black; font-size: 1.5rem">{{ $t('project.all_project', {count: Object.keys(hashProject).length}) }}</h1>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <v-container style="max-width: 1800px">
        <div class="py-12 rounded-lg mb-15">
          <div v-if="hashProject && Object.keys(hashProject).length">
            <div v-for="(project, index) in hashProject" :key="index" width="100%" flat
              class="w-full py-10 px-5 mb-5 rounded-3xl grey lighten-4">
              <template>
                <div class="mb-2 px-7 d-flex justify-space-between">
                  <div class="text-black d-flex">
                    <div>
                      <v-icon left>mdi-store</v-icon>
                    </div>
                    <div>
                      <h2 class="mb-2 me-5 dark--text"> {{ project.name }} <v-chip
                          :color="project.packageEndDateDays.number == 1 ? 'warning' : project.packageEndDateDays.number > 1 ? 'success' : 'error'"
                          v-if="project.packageEndDate && project.packageEndDateText && project.packageEndDateDays"
                          style="vertical-align:top;" class="ml-2">
                          <span v-if="project.packageEndDateDays.number == 1">{{ $t('project.package_end_thisday') }}</span>
                          <span v-else-if="project.packageEndDateDays.number > 1">{{ $t('project.package_end_more', {count: project.packageEndDateDays.text}) }}</span>
                          <span v-else>{{ $t('project.package_end_less', {date: project.packageEndDateText}) }}</span>
                        </v-chip>
                      </h2>
                      <h4 v-if="project.overAllData">
                        <span class>{{ $t('area.all_stall') }}</span>
                        <span class="mx-3 primary--text">
                          {{ project.overAllData.count }}
                        </span>
                        <span class>{{ $t('area.stall_and_rental_rate') }}</span>
                        <span class="mx-3 primary--text">
                          {{ rate(project.overAllData.occupied, project.overAllData.count) | currency }}%
                        </span>
                        <span class>{{ $t('area.space') }}</span>
                        <span class="mx-3 primary--text">
                          {{ project.overAllData.size | currency }}
                        </span>
                        <span class>{{ $t('square_meter') }}</span>
                      </h4>
                      <template v-if="project.overAllData && Object.keys(project.overAllData.hashMarketGroup).length">
                        <h4 v-for="(group, index) in project.overAllData.hashMarketGroup" :key="index">
                          <span class>{{ group.groupName }}</span>
                          <span class="mx-3 primary--text">
                            {{ group.count }}
                          </span>
                          <span class>{{ $t('area.stall_and_rental_rate') }}</span>
                          <span class="mx-3 primary--text">
                            {{ rate(group.occupied, group.count) | currency }}%
                          </span>
                          <span class>{{ $t('area.space') }}</span>
                          <span class="mx-3 primary--text">
                            {{ group.size | currency }}
                          </span>
                          <span class>{{ $t('square_meter') }}</span>
                        </h4>
                      </template>
                    </div>
                  </div>

                  <div class="project-btn-group">
                    <v-btn v-show="!project.disableViewBoard" v-if="project.role == 'admin' || project.enableViewBoard"
                      elevation="0" color="primary" :to="`/project/${project.objectId}/board`"
                      :disabled="project.isPackageExpired">
                      <v-icon left>mdi-newspaper-variant-outline</v-icon>
                      {{ $t('project.news_board', {name: project.name}) }}
                    </v-btn>
                    <v-btn v-if="(project.role == 'admin' || project.enableViewOverAll) && false" elevation="0"
                      color="primary" :to="`/project/${project.objectId}/overall`" :disabled="project.isPackageExpired">
                      <v-icon left>mdi-chart-bar</v-icon>{{ $t('analyze') }}
                    </v-btn>
                    <v-btn v-if="project.role == 'admin' || project.enableViewReport" elevation="0" color="primary"
                      @click="goToReport(project)" :disabled="project.isPackageExpired">
                      <v-icon left>mdi-chart-bar</v-icon>{{ $t('project.report') }}
                    </v-btn>
                    <v-btn v-if="project.layoutType == 1" elevation="0" color="primary" @click="goToPlan(project)"
                      :disabled="project.isPackageExpired">
                      <v-icon left>mdi-map-legend</v-icon>{{ $t('project.plan', { name: '' }) }}
                    </v-btn>
                    <v-btn v-if="project.role == 'admin'" elevation="0" color="primary" @click="goToSetting(project)"
                      :disabled="project.isPackageExpired">
                      <v-icon left>mdi-cog</v-icon>{{ $t('setting.title') }}
                    </v-btn>
                  </div>
                </div>
                <v-col>
                  <div class="grid grid-cols-3 px-6 gap-5" v-if="project.overAllData">
                    <div class="text-center px-5 py-8 bg-white rounded-m8 border-b-4 border-red-500 rounded-md">
                      <v-icon left color="error">mdi-file-document-multiple</v-icon>
                      {{ $t('payment.pending_payment_area', {count: $helper.toArabic(project.overAllData.unpaid) || 0}) }}
                    </div>
                    <div class="text-center border-b-4 border-screamin-green-700 px-5 py-8 bg-white rounded-md">
                      <v-icon left color="green">mdi-account-multiple-check</v-icon>
                      {{ $t('project.renter', {count: $helper.toArabic(project.overAllData.occupied) || 0}) }}
                    </div>
                    <div class="text-center px-5 py-8 border-b-4 border-picton-blue-600 bg-white rounded-md">
                      <v-icon left color="blue">mdi-account</v-icon>
                      {{ $t('project.vacancy', {count: $helper.toArabic(project.overAllData.vacancy) || 0}) }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <section class="px-5">
                    <v-row>
                      <v-col cols="12" v-if="project.isPackageExpired">
                        <div class="package-expired-box">
                          <div class="package-expired-header">{{ $t('project.package_expired') }}</div>
                          <div class="package-expired-contract">
                            {{ $t('project.package_expired_contact') }}
                            <a href="https://www.myket.in.th/#contract" alt="contract-us" target="_blank">{{ $t('project.package_expired_contact_link') }}</a>
                          </div>
                        </div>
                      </v-col>
                      <v-col v-else cols="12" v-for="(market, index) in project.markets" :key="`market_${index}`">
                        <project-market :project="project" :market="market" :projectId="project.objectId" :marketInfo="market.objectId && hashMarketInfo && hashMarketInfo[market.objectId]
                          ? hashMarketInfo[market.objectId]
                          : null
                          " />
                      </v-col>
                    </v-row>
                  </section>
                </v-col>
              </template>
            </div>
          </div>
        </div>
      </v-container>
      <v-snackbar v-model="isError" color="error" top>
        <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
      </v-snackbar>
    </template>
  </section>
</template>

<script>
import { mapState } from "vuex";
import ProjectMarket from "../../components/ProjectMarket.vue";
import { Market } from "../../classes";
import moment from "moment";
export default {
  components: { ProjectMarket },
  name: "Project",
  computed: {
    ...mapState({
      sessionAdmins: state => state.admin.sessionAdmins,
      sessionEmployees: state => state.employee.sessionEmployees
    })
  },
  data() {
    return {
      isLoading: false,
      markets: [],
      hashMarketInfo: null,
      isError: false,
      hashProject: {}
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      this.isLoading = true;
      try {
        for (let admin of this.sessionAdmins) {
          if (!this.hashProject[admin.project.objectId]) {
            this.hashProject[admin.project.objectId] = {
              ...admin.project,
              approveTask: admin.countApproveTask,
              markets: [],
              role: "admin"
            };
          }
          if (admin.market) {
            admin.market.approveTask = admin.countApproveTask;
            this.hashProject[admin.project.objectId].markets.push(admin.market);
            this.markets.push(admin.market);
          }
        }

        for (let employee of this.sessionEmployees) {
          if (!this.hashProject[employee.project.objectId]) {
            this.hashProject[employee.project.objectId] = {
              ...employee.project,
              markets: [],
              role: "employee"
            };
          }
          if (employee.market) {
            employee.market.approveTask = employee.countApproveTask;
            this.hashProject[employee.project.objectId].markets.push(
              employee.market
            );
            this.markets.push(employee.market);
          }
          if (
            employee.enableViewAccountingProject ||
            employee.enableViewReportsProject
          ) {
            this.hashProject[employee.project.objectId].enableViewReport = true;
          }
          if (employee.enableViewBoard) {
            this.hashProject[employee.project.objectId].enableViewBoard = true;
          }
        }

        if (this.hashProject) {
          const sortedUsers = Object.entries(this.hashProject)
            .sort((a, b) => moment(a[1].createdAt) - moment(b[1].createdAt))
          const sortedData = Object.fromEntries(sortedUsers);
          this.hashProject = sortedData
        }

        this.isLoading = false;
        if (this.markets && this.markets.length) {
          this.markets.sort(function (a, b) {
            return moment(a.createdAt) - moment(b.createdAt);
          });
          this.hashMarketInfo = await Market.getMarketsSummaryInfo(
            this.markets.map(d => {
              return d && d.objectId ? d.objectId : null;
            })
          );
        }
        for (let projectId in this.hashProject) {
          for (let market of this.hashProject[projectId].markets) {
            if (market.objectId && this.hashMarketInfo[market.objectId]) {
              if (!this.hashProject[projectId].overAllData) {
                this.hashProject[projectId].overAllData = {
                  hashMarketGroup: {},
                  count: 0,
                  size: 0,
                  occupied: 0,
                  unpaid: 0,
                  vacancy: 0,
                  occupancyRate: 0
                };
              }
              if (market.groupName) {
                if (!this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName]) {
                  this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName] = {
                    count: 0,
                    size: 0,
                    occupied: 0,
                    unpaid: 0,
                    vacancy: 0,
                    occupancyRate: 0
                  };
                }
                this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName].groupName = market.groupName;
                this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName].count += this.hashMarketInfo[market.objectId].count || 0;
                this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName].size += this.hashMarketInfo[market.objectId].size || 0;
                this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName].occupied += this.hashMarketInfo[market.objectId].occupied || 0;
                this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName].unpaid += this.hashMarketInfo[market.objectId].unpaid || 0;
                this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName].vacancy += this.hashMarketInfo[market.objectId].vacancy || 0;
              }

              this.hashProject[projectId].overAllData.count += this.hashMarketInfo[market.objectId].count || 0;
              this.hashProject[projectId].overAllData.size += this.hashMarketInfo[market.objectId].size || 0;
              this.hashProject[projectId].overAllData.occupied += this.hashMarketInfo[market.objectId].occupied || 0;
              this.hashProject[projectId].overAllData.unpaid += this.hashMarketInfo[market.objectId].unpaid || 0;
              this.hashProject[projectId].overAllData.vacancy += this.hashMarketInfo[market.objectId].vacancy || 0;
            }
            this.hashProject[projectId].overAllData.occupancyRate = this.rate(
              this.hashProject[projectId].overAllData.occupied,
              this.hashProject[projectId].overAllData.count
            );
            if (this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName]) {
              this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName].occupancyRate = this.rate(
                this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName].occupied,
                this.hashProject[projectId].overAllData.hashMarketGroup[market.groupName].count
              );
            }
          }
        }


      } catch (error) {
        console.log(error);
        this.isError = true;
        this.isLoading = false;
      }
    },
    rate(value, value2) {
      const rate = (value / value2) * 100;
      return rate ? rate : 0;
    },
    goToSetting(project) {
      this.$store.commit("markets/setProjectId", {
        projectId: project.objectId
      });
      this.$router.push(`/project/${project.objectId}/settings`);
    },
    goToReport(project) {
      this.$store.commit("markets/setProjectId", {
        projectId: project.objectId
      });
      this.$router.push(`/project/${project.objectId}/reports`);
    },
    goToPlan(project) {
      this.$store.commit("markets/setProjectId", {
        projectId: project.objectId
      });
      this.$router.push(`/project/${project.objectId}/plan`);
    }
  }
};
</script>

<style lang="scss" scoped>
.package-expired-box {
  width: 100%;
  text-align: center;
  padding: 25px;
  // margin: 10px 15px;
  background: rgba(255, 102, 102, 0.192);
  border-radius: 15px;

  .package-expired-header {
    font-size: 25px;
    color: rgb(170, 0, 0);
  }

  .package-expired-contract {
    font-size: 17px;
    font-weight: 400;

    a {
      color: blue;
    }

    a:hover {
      text-decoration: underline;
    }
  }
}

.project-btn-group {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 5px;
  flex-wrap: wrap;
  align-content: flex-start;
}
</style>
